import { render, staticRenderFns } from "./MethodsAndTerms.vue?vue&type=template&id=b73ba894"
import script from "./MethodsAndTerms.vue?vue&type=script&lang=js"
export * from "./MethodsAndTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports